<template>
  <div id="SectionManufacturingCompliance">
    <UIContainer>
      <template #left>
        <SectionTitle>
          <template #title>
            <span class="SectionManufacturingCompliance__title">
              GHG compliance challenges
            </span>
          </template>
          <template #description>
            <span class="SectionManufacturingCompliance__description">
              Companies face unprecedented pressure to reduce emissions while
              maintaining competitiveness. Complex supply chains, and
              stakeholder demands create a perfect storm of compliance
              challenges.
            </span>
          </template>
        </SectionTitle>

        <div class="SectionManufacturingCompliance__lists">
          <h3>Process challenges:</h3>
          <ul class="SectionManufacturingCompliance__list">
            <li>Manual carbon calculation errors</li>
            <li>Complex methodology</li>
          </ul>

          <h3>Compliance challenges:</h3>
          <ul class="SectionManufacturingCompliance__list">
            <li>Deadline stress</li>
            <li>Changing emission factors</li>
          </ul>
        </div>
      </template>

      <template #right>
        <img
          class="SectionManufacturingCompliance__image"
          src="../assets/compliance/compliance.avif"
          alt="Manufacturing compliance challenges"
        />
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
</script>

<style lang="scss" scoped>
#SectionManufacturingCompliance {
  .SectionManufacturingCompliance__title {
    @include font-size-18px();
    @include md {
      @include font-size-30px;
    }
  }
  .SectionManufacturingCompliance__description {
    @include font-size-16px();
    color: $color-ui-gray-cool-600;
    @include md {
      @include font-size-18px;
    }
  }

  .SectionManufacturingCompliance__cost {
    display: flex;
    border-left: 3px solid $color-ui-error-300;
    max-width: 31.25rem;
    width: 100%;
    margin-top: 1.5rem;

    @include md {
      margin-top: 3rem;
    }
  }

  .SectionManufacturingCompliance__cost-icon-container {
    margin: 0.25rem 0.5rem 0 1rem;
  }

  .SectionManufacturingCompliance__cost-icon {
    --size: 1.25rem;
    --color: #{$color-ui-error-600};
  }

  .SectionManufacturingCompliance__cost-title {
    @include font-size-16px;
    margin-bottom: 0.25rem;
    color: $color-ui-error-600;
    font-weight: 600;

    @include md {
      @include font-size-20px;
    }
  }

  .SectionManufacturingCompliance__cost-description {
    @include font-size-14px;
    color: $color-ui-gray-cool-700;

    @include md {
      @include font-size-16px;
    }
  }

  .SectionManufacturingCompliance__image {
    display: none;

    @include md {
      display: block;
      width: 100%;
      padding-left: 1rem;
    }
  }

  .SectionManufacturingCompliance__lists {
    margin-top: 1rem;
    @include font-size-18px;

    h3 {
      margin-bottom: 0.75rem;
    }
  }

  .SectionManufacturingCompliance__list {
    margin: 0 0 1rem 0;
    padding-left: 0.5rem; // remove browser default indent so text aligns with labels
    list-style-position: inside;
  }
}
</style>
